import { Backend } from '@/_axios';

export default {

  activeProjects(data) {
    return Backend.post('/api/dash/active-projects', data);
  },
  activeProjects2024(data) {
    return Backend.post('/api/dash/active-projects-2024', data);
  },
  // Pass id OR key
  projectIssues({ id, key, without_ignore_progress = false }) {
    return Backend.post('/api/dash/project-issues', { id, key, without_ignore_progress});
  },
  allProjectIssues() {
    return Backend.post('/api/dash/all-project-issues');
  },
  vacations() {
    return Backend.post('/api/dash/vacations');
  },
  planableUsers() {
    return Backend.post('/api/dash/planable-users');
  },
  planableInternalUsers() {
    return Backend.post('/api/dash/plan-internal-users');
  },
  allProjectDayLogs(data) {
    return Backend.post('/api/dash/all-project-day-logs', data);
  },
  allProjectDayLogsWithIssues(data) {
    return Backend.post('/api/dash/all-project-day-logs-with-issues', data);
  },
  syncProject({ id }) {
    return Backend.post('/api/dash/sync-project', { project_id: id });
  },
  plannedWork(data) {
    return Backend.post('/api/dash/planned-work', data);
  },
  WorkLogStats(date) {
    return Backend.post('/api/dash/WorkLogStats', { at_date: date || new Date() });
  },
  /**
   * projects = [] for all active, else array of jira keys
   */
  ProjectIssueForTimeStats({ projects }) {
    return Backend.post('/api/dash/ProjectIssueForTimeStats', { projects });
  },
  Absences({ days }) {
    return Backend.get('/api/dash/absences', { params: { days } });
  },
  Idle() {
    return Backend.get('/api/dash/idle');
  },
  backupStatistics() {
    return Backend.get('/api/dash/backup-statistics');
  }
};
